import { Button, Card, ListGroup } from "react-bootstrap";
import React, { useContext, useState } from "react";
import { ProductSubGroup } from "./ProductSubGroup";
import "./ProductGroup.scss";
import { IInteriorProductGroup } from "../../models/IChainInfo";
import { DebugContext } from "../../contexts/DebugContext";

export function ProductGroup(props: {
    group: IInteriorProductGroup
}) {

    const [collapsed, setCollapsed] = useState(true);
    const debugContext = useContext(DebugContext);

    const subGroups = props.group.interiorProductSubGroups
        .map(sg => <ProductSubGroup subGroup={sg} key={sg.id} />);

    const icon = collapsed
        ? "/imgs/icons/glyphicons-halflings-131-chevron-right.svg"
        : "/imgs/icons/glyphicons-halflings-128-chevron-down.svg"
        ;


    return (
        <Card className="product-group"
            data-collapsed={collapsed}
        >
            <Card.Header >
                <Button variant="btn-link btn-block text-left"
                    onClick={() => setCollapsed(!collapsed)}
                >
                    <img className="collapse-icon" src={icon} alt="" />

                    {debugContext.value.displayExtendedProductInfo && (props.group.externalId + " - ")}

                    {props.group.name}
                </Button>
            </Card.Header>

            <Card.Body>

                <ListGroup variant="flush" >
                    {subGroups}
                </ListGroup>
            </Card.Body>
        </Card>
        );
}
